import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-qr-code',
  templateUrl: './demo-qr-code.component.html',
  styleUrls: ['./demo-qr-code.component.css']
})
export class DemoQrCodeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
